
import { textSearch } from "@/assets/ts/_utils";
import JsonExcel from "@/components/widgets/tables/JsonExcel.vue";
import { InscripcionEstado } from "@/enums";
import { Inscripcion } from "@/store/models";
import { CursosModule } from "@/store/modules";
import { ArrowDown } from "@element-plus/icons-vue";
import { AxiosResponse } from "axios";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

export default defineComponent({
  name: "servicios-listado",
  components: { "download-excel": JsonExcel, ArrowDown },
  props: {
    inscripciones: Object as () => Inscripcion[],
  },

  methods: {
    formatLongDate(fecha) {
      return moment(fecha).locale("es").format("L");
    },
    formatHour(fecha) {
      return moment(fecha).format("HH:mm");
    },
  },
  setup(props) {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const module = getModule(CursosModule, store);

    const csvLabels = {
      alumno: t("csv.listados.inscripciones.alumno"),
      dni: t("csv.listados.inscripciones.dni"),
      email: t("csv.listados.inscripciones.email"),
      telefono: t("csv.listados.inscripciones.telefono"),
      modalidad: t("csv.listados.inscripciones.modalidad"),
      estado: t("csv.listados.inscripciones.estado"),
      fechaEnvio: t("csv.listados.inscripciones.fechaEnvio"),
    };

    const csvFields = [
      "alumno",
      "dni",
      "email",
      "telefono",
      "modalidad",
      "estado",
      "fechaEnvio",
    ];
    const csvName = "diplomasListado" + new Date().getTime() + ".xlsx";

    const search = ref("");

    const sortInscripcionEstado = function (a, b) {
      let primero = a.estado;
      let segundo = b.estado;
      if (primero > segundo) {
        return 1;
      }
      if (primero < segundo) {
        return -1;
      }
      return 0;
    };

    const loading = ref(false);

    const handleEdit = (index, row) => {
      router.push(`/listados/servicios-programados/${row.id}`);
    };
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    const onInscrito = async (row) => {
      const idInscripcion = row.id;
      const estado = "INSCRITO";

      const plazasTotales = module.curso?.plazas;
      if (!plazasTotales) {
        return;
      }
      // Contabilizamos todas las plazas con estado INSCRITO o FINALIZADO y también la plaza del propio alumno para que permita cambio de INSCRITO a FINALIZADO con todas las plazas completas

      const plazasUtilizadas =
        module.curso?.inscripciones
          ?.filter(
            (i) =>
              i.estado === InscripcionEstado.inscrito ||
              i.estado === InscripcionEstado.finalizado
          )
          .filter((u) => u.id !== row.id).length ?? 0;

      if (plazasTotales <= plazasUtilizadas) {
        Swal.fire({
          html: t("dialogs.ocuparPlazaInscripcion.limitePlazas.body", {
            plazasTotales: plazasTotales,
            plazasUtilizadas: plazasUtilizadas,
          }),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }

      loading.value = true;
      try {
        await module
          .updateInscripcion({
            id: idInscripcion as string,
            inscripcion: {
              estado: estado,
            },
          })
          .then(async () => {
            if (!module.errors?.error) {
              const token = route.params.id;
              await module.fetchById({
                id: token as string,
              });
              Swal.fire({
                text: t("formularios.inscripcion.cambioEstado.mensaje.exito"),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: t("dialogs.okButton"),
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            } else {
              swalWithBootstrapButtons.fire(
                t("dialogs.error"),
                t("formularios.inscripcion.cambioEstado.mensaje.error"),
                "error"
              );
            }
          });
      } catch (err) {
        console.error("Error aprobar", err);
        Swal.fire({
          text: t("formularios.inscripcion.cambioEstado.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        loading.value = false;
      }
    };
    const onFinalizado = async (row) => {
      const idInscripcion = row.id;
      const estado = "FINALIZADO";

      const plazasTotales = module.curso?.plazas;
      if (!plazasTotales) {
        return;
      }
      // Contabilizamos todas las plazas con estado INSCRITO o FINALIZADO y también la plaza del propio alumno para que permita cambio de INSCRITO a FINALIZADO con todas las plazas completas
      const plazasUtilizadas =
        module.curso?.inscripciones
          ?.filter(
            (i) =>
              i.estado === InscripcionEstado.inscrito ||
              i.estado === InscripcionEstado.finalizado
          )
          .filter((u) => u.id !== row.id).length ?? 0;

      if (plazasTotales <= plazasUtilizadas) {
        Swal.fire({
          html: t("dialogs.ocuparPlazaInscripcion.limitePlazas.body", {
            plazasTotales: plazasTotales,
            plazasUtilizadas: plazasUtilizadas,
          }),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }

      loading.value = true;
      try {
        await module
          .updateInscripcion({
            id: idInscripcion as string,
            inscripcion: {
              estado: estado,
            },
          })
          .then(async () => {
            if (!module.errors?.error) {
              const token = route.params.id;
              await module.fetchById({
                id: token as string,
              });
              Swal.fire({
                text: t("formularios.inscripcion.cambioEstado.mensaje.exito"),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: t("dialogs.okButton"),
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            } else {
              swalWithBootstrapButtons.fire(
                t("dialogs.error"),
                t("formularios.inscripcion.cambioEstado.mensaje.error"),
                "error"
              );
            }
          });
      } catch (err) {
        console.error("Error aprobar", err);
        Swal.fire({
          text: t("formularios.inscripcion.cambioEstado.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        loading.value = false;
      }
    };
    const onAbandono = async (row) => {
      const idInscripcion = row.id;
      const estado = "ABANDONO";

      loading.value = true;
      try {
        await module
          .updateInscripcion({
            id: idInscripcion as string,
            inscripcion: {
              estado: estado,
            },
          })
          .then(async () => {
            if (!module.errors?.error) {
              const token = route.params.id;
              await module.fetchById({
                id: token as string,
              });
              Swal.fire({
                text: t("formularios.inscripcion.cambioEstado.mensaje.exito"),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: t("dialogs.okButton"),
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            } else {
              swalWithBootstrapButtons.fire(
                t("dialogs.error"),
                t("formularios.inscripcion.cambioEstado.mensaje.error"),
                "error"
              );
            }
          });
      } catch (err) {
        console.error("Error aprobar", err);
        Swal.fire({
          text: t("formularios.inscripcion.cambioEstado.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        loading.value = false;
      }
    };
    const onCancelado = async (row) => {
      const idInscripcion = row.id;
      const estado = "CANCELADO";

      loading.value = true;
      try {
        await module
          .updateInscripcion({
            id: idInscripcion as string,
            inscripcion: {
              estado: estado,
            },
          })
          .then(async () => {
            if (!module.errors?.error) {
              const token = route.params.id;
              await module.fetchById({
                id: token as string,
              });
              Swal.fire({
                text: t("formularios.inscripcion.cambioEstado.mensaje.exito"),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: t("dialogs.okButton"),
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            } else {
              swalWithBootstrapButtons.fire(
                t("dialogs.error"),
                t("formularios.inscripcion.cambioEstado.mensaje.error"),
                "error"
              );
            }
          });
      } catch (err) {
        console.error("Error aprobar", err);
        Swal.fire({
          text: t("formularios.inscripcion.cambioEstado.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        loading.value = false;
      }
    };
    const onListaDeEspera = async (row) => {
      const idInscripcion = row.id;
      const estado = "LISTA_DE_ESPERA";

      loading.value = true;
      try {
        await module
          .updateInscripcion({
            id: idInscripcion as string,
            inscripcion: {
              estado: estado,
            },
          })
          .then(async () => {
            if (!module.errors?.error) {
              const token = route.params.id;
              await module.fetchById({
                id: token as string,
              });
              Swal.fire({
                text: t("formularios.inscripcion.cambioEstado.mensaje.exito"),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: t("dialogs.okButton"),
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            } else {
              swalWithBootstrapButtons.fire(
                t("dialogs.error"),
                t("formularios.inscripcion.cambioEstado.mensaje.error"),
                "error"
              );
            }
          });
      } catch (err) {
        console.error("Error aprobar", err);
        Swal.fire({
          text: t("formularios.inscripcion.cambioEstado.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        loading.value = false;
      }
    };

    const registros = computed(() => {
      return props.inscripciones?.map((row) => {
        return {
          ...row,
          alumno: row.nombre + " " + row.apellidos,
          modalidad:
            row.videoconferencia && row.presencial
              ? "Aula Virtual / Presencial"
              : row.videoconferencia
              ? "Aula Virtual"
              : "Presencial",
          fechaEnvio: row.diplomaEnviado
            ? moment(row.diplomaEnviado).format("D/M/Y")
            : "",
        };
      });
    });
    const inscripcionesActivas = computed(() => {
      return (
        props.inscripciones?.filter(
          (ele) =>
            ele.estado === InscripcionEstado.inscrito ||
            ele.estado === InscripcionEstado.finalizado
        ).length || 0
      );
    });
    const countInscripciones = computed(() => {
      return props.inscripciones?.length || 0;
    });

    const datosCurso = computed(() => {
      return module.curso;
    });

    const getTagType = (estado: string) => {
      switch (estado) {
        case InscripcionEstado.inscrito:
        case InscripcionEstado.finalizado:
          return "success";
        case InscripcionEstado.listaDeEspera:
          return "primary";
        default:
          return "danger";
      }
    };

    const sanitizeFilename = (filename: string) => {
      if (typeof filename !== "string") return "";
      return (
        filename
          // 1. Normaliza el texto descomponiendo los caracteres con acentos (ej: "á" se convierte en "a" + un acento flotante)
          .normalize("NFD")
          // 2. Elimina los acentos y diacríticos flotantes
          .replace(/[\u0300-\u036f]/g, "")
          // 3. Reemplaza uno o más espacios en blanco por un solo guion bajo
          .replace(/\s+/g, "_")
          // 4. Elimina cualquier carácter que no sea letra, número, guion bajo, guion medio o punto
          .replace(/[^a-zA-Z0-9_.-]/g, "")
          // 5. Evita que queden múltiples guiones bajos o medios consecutivos
          .replace(/_{2,}/g, "_")
          .replace(/-{2,}/g, "-")
          // 6. Remueve guiones o puntos sobrantes al inicio o al final del nombre
          .replace(/^[_.-]+|[_.-]+$/g, "")
      );
    };

    return {
      inscripcionesListado: computed(() =>
        registros.value?.filter((data) => {
          const modalidad =
            data.videoconferencia && data.presencial
              ? "Aula Virtual / Presencial"
              : data.videoconferencia
              ? "Aula Virtual"
              : "Presencial";
          return (
            !search.value ||
            textSearch(data.nombre, search.value) ||
            textSearch(data.apellidos, search.value) ||
            textSearch(data.dni, search.value) ||
            textSearch(data.telefono, search.value) ||
            textSearch(data.email, search.value) ||
            textSearch(modalidad, search.value) ||
            textSearch(t(`inscripciones.estado.${data.estado}`), search.value)
          );
        })
      ),
      csvLabels,
      csvFields,
      csvName,
      loading,
      search,
      sortInscripcionEstado,
      handleEdit,
      getTagType,
      onInscrito,
      onFinalizado,
      onAbandono,
      onCancelado,
      onListaDeEspera,
      InscripcionEstado,
      inscripcionesActivas,
      countInscripciones,
      /*
      enviarDiplomaTodos: () => {
        loading.value = true;
        module
          .enviarDiplomaTodos({ cursoId: datosCurso.value?.id as string })
          .then(() => {
            const token = route.params.id;
            module.fetchById({
              id: token as string,
            });
          })
          .then(() => {
            if (datosCurso.value) {
              datosCurso.value.diplomaEnviado = new Date();
            }
            loading.value = false;
            return Swal.fire({
              text: t("formularios.diplomas.enviarDiplomaTodos.mensaje.exito"),
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          })
          .catch((err) => {
            loading.value = false;
            Swal.fire({
              text: t("formularios.diplomas.enviarDiplomaTodos.mensaje.error"),
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
            console.error(err);
          });
      },
      enviarDiploma: (row) => {
        console.log("enviarDiploma", row);
        loading.value = true;
        module
          .enviarDiploma({ cursoId: row.cursoId, id: row.id })
          .then(() => {
            const token = route.params.id;
            module.fetchById({
              id: token as string,
            });
          })
          .then(() => {
            loading.value = false;
            return Swal.fire({
              text: t("formularios.diplomas.enviarDiploma.mensaje.exito"),
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          })
          .catch((err) => {
            loading.value = false;
            Swal.fire({
              text: t("formularios.diplomas.enviarDiploma.mensaje.error"),
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
            console.error(err);
          });
      },
      */
      /*descargarDiplomaTodos: () => {
        loading.value = true;
        module
          .descargarDiplomaTodos({ cursoId: datosCurso.value?.id as string })
          .then(() => {
            const token = route.params.id;
            module.fetchById({
              id: token as string,
            });
          })
          .then(() => {
            if (datosCurso.value) {
              datosCurso.value.diplomaEnviado = new Date();
            }
            loading.value = false;
            return Swal.fire({
              text: t("formularios.diplomas.enviarDiplomaTodos.mensaje.exito"),
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          })
          .catch((err) => {
            loading.value = false;
            Swal.fire({
              text: t("formularios.diplomas.enviarDiplomaTodos.mensaje.error"),
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: t("dialogs.okButton"),
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
            console.error(err);
          });
      },*/
      descargarDiplomaTodos: async () => {
        try {
          loading.value = true;

          // Realiza la solicitud para descargar el ZIP
          const response = (await module.descargarDiplomaTodos({
            cursoId: datosCurso.value?.id as string,
          })) as AxiosResponse;

          if (!response || response.status !== 200) {
            throw new Error("Failed to download the file");
          }

          // Convierte la respuesta a un Blob
          const blob = new Blob([response.data], { type: "application/zip" });
          const url = window.URL.createObjectURL(blob);

          // Crea un enlace y desencadena la descarga
          const link = document.createElement("a");
          link.href = url;
          const zipFilename = sanitizeFilename(
            `diplomas-${datosCurso.value?.nombre}.zip`
          );
          link.setAttribute("download", zipFilename);
          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);

          const token = route.params.id;
          module.fetchById({
            id: token as string,
          });

          loading.value = false;
        } catch (err) {
          loading.value = false;
          Swal.fire({
            text: t("formularios.diplomas.descargarDiplomas.mensaje.error"),
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          console.error("Download error:", err);
        }
      },
      descargarDiploma: async (row) => {
        console.log("enviarDiploma", row);
        try {
          loading.value = true;

          const cursoId = row.cursoId;
          const inscripcionId = row.id;

          const response = (await module.descargarDiploma({
            cursoId: cursoId,
            id: inscripcionId,
          })) as AxiosResponse;

          // Convierte la respuesta a un Blob
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          // Crea un enlace y desencadena la descarga
          const link = document.createElement("a");
          link.href = url;
          const filename = sanitizeFilename(
            `diploma-${row.nombre}_${row.apellidos}.pdf`
          );
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);

          const token = route.params.id;
          module.fetchById({
            id: token as string,
          });

          loading.value = false;
        } catch (err) {
          loading.value = false;
          Swal.fire({
            text: t("formularios.diplomas.descargarDiploma.mensaje.error"),
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: t("dialogs.okButton"),
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          console.error(err);
        }
      },
      fechaEnvioDiplomas: computed(() => {
        if (!datosCurso.value?.diplomaEnviado) return "";
        return moment(datosCurso.value?.diplomaEnviado).format("D/M/Y");
      }),
      datosCurso,
    };
  },
});
